module.exports = __webpack_public_path__ + "assets/img/help_image04-1@2x.37b05809.png";